"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const IntegrationAppConnectionContext = createContext({
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  connectionId: null
});
IntegrationAppConnectionContext.displayName = "IntegrationAppConnectionContext";
function useIntegrationAppConnection() {
  return useContext(IntegrationAppConnectionContext);
}

export { IntegrationAppConnectionContext, useIntegrationAppConnection };
